// --------------------------------------------------------
// src/views/theme.view.js
//
// Manage the view/template of the themes
//
// --------------------------------------------------------
"use strict";

const THEME_TEMPLATE = `
	<a href="index.html#<%= app.getLanguage() %>/theme/<%= name %>">
		<h2 class="pull-left theme-name"><%= app.localeManager.get("themes." + name.toLowerCase()) %></h2>
	</a>
	<img src="./assets/images/icons/<%= ThemeComponent.parseImage(name) %>.png" class="theme-icon">
`;

const ThemeComponent = Backbone.View.extend({
	// The DOM element that will be created
	tagName: "div",

	// The className of the DOM element
	className: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-25 theme-container",

	// Converts the template to html
	template: _.template( THEME_TEMPLATE ),

	// Render the template
	render: function() {
		var template = this.template(this.model.toJSON());
		this.$el.html(template);
		
		return this;
	},

});

/**
 * Replace single whitespace from a string to an "_" (underscore)
 *
 * @param str
 * @return String
 */
ThemeComponent.parseImage = function(str){
	return str.replace(/ /g, "_").toLowerCase();
};

/**
 * Animate a specific selector
 *
 * @param selector
 * @return void
 */
ThemeComponent.animate = function(selector) {
	new TimelineMax()
		.staggerFrom(selector, 2, { y: -30, opacity: 0, ease:Elastic.easeOut, yoyo: true }, 0.2);
};
